import TableauDesTranches from "../../../configuration/shared/classes/tableau-des-tranches";

export class TranchesLot {
    trl_id: string;
    trl_tdt_id: string;
    trl_batiment_id: string;
    trl_lot_id: string;
    tableau_de_tranche: TableauDesTranches;

    constructor(init?: Partial<TranchesLot>) {
        Object.assign(this, init);
    }
}
